
const AccessTokenKey = 'TOKEN'
const RefreshTokenKey = 'REFRESH_TOKEN'

//存储token
export const setToken = (token, refreshToken) => {
  //持久化存储token
  localStorage.setItem(AccessTokenKey, token)
  localStorage.setItem(RefreshTokenKey, refreshToken)
}

export function getRefreshToken() {
  return localStorage.getItem(RefreshTokenKey)
}

//获取token
export const getToken = () => {
  return localStorage.getItem(AccessTokenKey)
}

export const removeToken = () => {
  localStorage.removeItem(AccessTokenKey)
  localStorage.removeItem(RefreshTokenKey)
}


// WEBPACK FOOTER //
// ./src/utils/token.js